// extracted by mini-css-extract-plugin
module.exports = {"articleList":"article-listing-styling-module--articleList--1IGbk"};